"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./style.scss");
const Button = (props) => {
    const { dataStopProp, color = 'default', className = '', borderRadius = 'sm', disabled = false, children, onBlur, onClick, onFocus, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove } = props;
    const handleOnClick = (event) => {
        if (onClick)
            onClick(event);
    };
    const handleOnBlur = (event) => {
        if (onBlur)
            onBlur(event);
    };
    const handleOnFocus = (event) => {
        if (onFocus)
            onFocus(event);
    };
    const handleOnKeyDown = (event) => {
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    const handleKeyUp = (event) => {
        if (onKeyUp) {
            onKeyUp(event);
        }
    };
    const handleOnMouseDown = (event) => {
        if (onMouseDown) {
            onMouseDown(event);
        }
    };
    const handleOnMouseLeave = (event) => {
        if (onMouseLeave) {
            onMouseLeave(event);
        }
    };
    const handleOnMouseUp = (event) => {
        if (onMouseUp) {
            onMouseUp(event);
        }
    };
    const handleOnTouchEnd = (event) => {
        if (onTouchEnd) {
            onTouchEnd(event);
        }
    };
    const handleOnTouchMove = (event) => {
        if (onTouchMove)
            onTouchMove(event);
    };
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ draggable: false, "data-stop-prop": dataStopProp, className: `button-${color} borderRadius-${borderRadius} ${className}`, onClick: handleOnClick, onBlur: handleOnBlur, onFocus: handleOnFocus, onKeyUp: handleKeyUp, onKeyDown: handleOnKeyDown, onMouseDown: handleOnMouseDown, onMouseLeave: handleOnMouseLeave, onMouseUp: handleOnMouseUp, onTouchEnd: handleOnTouchEnd, onTouchMove: handleOnTouchMove, disabled: disabled }, { children: children })));
};
exports.default = Button;
